module.exports = __webpack_public_path__ + "static/media/storeBcg.46143c2f.jpeg";